module.exports = __webpack_public_path__ + "img/Game_target_Z-29.c2af7c00.png";